import ReactDOM from 'react-dom/client';
import App from './Modemaker';
import NavigationContextProvider from './Context/NavigationContext';
import GlobalContextProvider from './Context/GlobalContext';
import DeviceContextProvider from './Context/DeviceContext';
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <GlobalContextProvider>
    <NavigationContextProvider>
      <DeviceContextProvider>
        <DndProvider backend={HTML5Backend}>
          <App />
        </DndProvider>
      </DeviceContextProvider>
    </NavigationContextProvider>
  </GlobalContextProvider>
);